export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10191.c31e3bbb.jpg";